import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";

const PickColorsInput = ({ onColorPicked }) => {
  const [selected, setSelected] = useState(null);
  const [selectedColors, setSelectedColors] = useState({
    primary: "grey",
    secondary: "grey",
    text: "black",
  });

  const handleChangeComplete = (color) => {
    const newColor = { ...selectedColors, [selected]: color.hex };
    setSelectedColors({ ...selectedColors, [selected]: color.hex });
    onColorPicked(newColor);
  };
  return (
    <div
      className="divRow"
      style={{
        width: "80%",
        justifyContent: "space-around",
        position: "relative",
      }}
    >
      <div
        className="divRow"
        onClick={() => {
          setSelected("primary");
        }}
        style={{
          cursor: "pointer",
          justifyContent: "center",
          height: "100%",
          alignContent: "center",
        }}
      >
        <div
          className="textBoldWhite"
          style={{ color: "#1f1f1f", marginRight: "5px" }}
        >
          Primary Color
        </div>
        <div
          style={{
            width: "30px",
            height: "30px",
            border: "4px solid black",
            borderRadius: ".5rem/.5rem",
            backgroundColor: selectedColors.primary,
          }}
        />
      </div>
      <div
        className="divRow"
        onClick={() => {
          setSelected("secondary");
        }}
        style={{
          cursor: "pointer",
          justifyContent: "center",
          height: "100%",
          alignContent: "center",
        }}
      >
        <div
          className="textBoldWhite"
          style={{ color: "#1f1f1f", marginRight: "5px" }}
        >
          Secondary Color
        </div>
        <div
          style={{
            border: "4px solid black",
            borderRadius: ".5rem/.5rem",
            width: "30px",
            height: "30px",
            backgroundColor: selectedColors.secondary,
          }}
        />
      </div>
      <div
        className="divRow"
        onClick={() => {
          setSelected("text");
        }}
        style={{
          padding: "5px",
          borderRadius: ".5rem/.5rem",
          cursor: "pointer",
          backgroundColor: selectedColors.primary,
        }}
      >
        <div className="textBold" style={{ color: selectedColors.text }}>
          Pick Text Color
        </div>
      </div>
      {selected && (
        <div style={{ position: "absolute", zIndex: 1 }}>
          <SketchPicker
            color={selectedColors[selected]}
            onChangeComplete={handleChangeComplete}
          />
          <div
            onClick={() => {
              setSelected("");
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              width: "100%",
              justifyContent: "center",
              backgroundColor: "#2f2f2f",
            }}
          >
            <div className="textBoldWhite" style={{ fontSize: "20px" }}>
              Done
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PickColorsInput;
